var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreastFormulaFeeding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Breast & Formula Feeding.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Breast & Formula Feeding",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(59.7298,48.1313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -2.726,0.314 -5.368,-0.461 -7.249,-2.127 -1.816,-1.607 -2.892,-3.858 -3.031,-6.337 -0.138,-2.464 0.677,-4.808 2.292,-6.597 2.669,-2.958 6.043,-3.895 9.758,-2.711 3.725,1.188 5.879,3.852 6.401,7.915 0.099,0.771 0.408,3.126 -1.872,6.325 C 4.922,-1.59 2.626,-0.303 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(49.4464,31.4036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -3.171,-9.937 c 2.462,2.174 4.744,4.45 6.94,6.923 C 2.295,-2.251 1.055,-1.259 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(53.1535,56.5749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 0.023 v 0 c 7.606,0.012 13.352,5.804 13.364,13.472 0.006,3.541 -1.409,6.906 -3.982,9.475 -2.523,2.517 -5.8,3.901 -9.233,3.901 H 0.125 C -7.341,26.821 -13.4,20.8 -13.381,13.425 -13.361,5.893 -7.485,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(47.3985,34.8674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.418,1.184 -0.659,2.355 -0.732,3.564 -0.01,-0.002 -0.02,-0.006 -0.03,-0.009 -3.029,-0.958 -6.04,-2.131 -9.206,-3.586 -1.202,-0.552 -2.563,-1.178 -3.612,-2.211 -2.041,-2.011 -2.744,-4.14 -2.15,-6.51 0.688,-2.742 2.152,-4.95 4.353,-6.561 1.874,-1.374 3.889,-1.649 5.987,-0.817 0.103,0.04 0.232,0.162 0.266,0.249 1.955,5.062 3.669,10.323 5.094,15.637 C 0.019,-0.061 0.001,-0.002 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(69.677,51.7128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.911,1.871 -4.154,3.173 -6.819,3.439 -2.763,-1.801 -6.074,-2.85 -9.674,-2.856 h -0.031 c -3.613,0 -6.935,1.047 -9.705,2.849 -2.365,-0.267 -4.434,-1.331 -6.152,-2.984 -4.156,-3.997 -8.242,-8.071 -12.237,-12.227 -1.96,-2.038 -1.694,-5.334 0.312,-7.332 1.155,-1.15 2.492,-1.758 3.83,-1.799 0.56,1.471 1.502,2.633 2.244,3.449 1.263,1.389 2.856,2.235 4.389,2.942 1.415,0.653 2.792,1.238 4.154,1.792 0.166,0.15 0.295,0.263 0.364,0.316 v -0.168 c 2.17,0.871 4.295,1.636 6.405,2.283 0.107,0.033 0.118,0.036 0.172,0.278 0.927,4.219 3.913,7.548 7.989,8.906 4.07,1.356 8.45,0.486 11.715,-2.327 2.657,-2.29 4.183,-5.616 4.183,-9.127 0,-1.363 -0.236,-2.697 -0.673,-3.955 0.967,-0.86 1.924,-1.713 2.642,-2.359 1.221,-1.098 2.497,-2.008 4.14,-2.008 0.267,0 0.541,0.022 0.823,0.068 2.119,0.342 3.728,1.446 4.472,3.495 0.868,2.389 0.17,4.5 -1.554,6.261 C 7.352,-7.35 3.714,-3.636 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(86.2427,32.9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.243,-3.424 -4.018,-5.647 -7.813,-6.26 -0.501,-0.081 -1.007,-0.122 -1.505,-0.122 -1.703,0 -4.186,0.495 -6.645,2.755 0.003,-5.971 -0.013,-20.033 -0.013,-20.061 0,-1.18 -0.958,-2.138 -2.138,-2.138 -1.181,0 -2.138,0.958 -2.138,2.138 v 0 c 0,0 0.009,20.289 0.009,20.289 -2.803,-2.144 -6.051,-2.901 -9.68,-2.213 -0.211,0.04 -0.279,0.016 -0.425,-0.152 -2.98,-3.422 -5.874,-6.275 -8.847,-8.724 -2.202,-1.813 -4.409,-2.767 -6.699,-2.918 0,-2.155 10e-4,-4.269 0.002,-6.282 0,-1.18 -0.957,-2.138 -2.138,-2.138 -1.181,0 -2.138,0.958 -2.138,2.138 -0.003,1.805 -0.004,4.29 -0.005,7.012 -1.137,0.508 -2.216,1.265 -3.223,2.282 -0.514,0.518 -0.963,1.101 -1.398,1.665 -0.195,0.252 -0.389,0.505 -0.589,0.752 l -0.018,0.024 c -0.049,0.072 -0.097,0.144 -0.144,0.216 -1.121,1.721 -1.766,3.514 -1.954,5.357 -2.32,0.157 -4.571,1.209 -6.393,3.022 -0.039,0.04 -0.073,0.083 -0.111,0.123 -1.332,-1.049 -3.016,-1.669 -4.84,-1.645 l -1.938,0.027 c -2.028,0.027 -3.929,0.836 -5.354,2.278 -1.454,1.473 -2.24,3.424 -2.212,5.493 l 0.11,8.179 c 0.017,1.224 0.327,2.403 0.919,3.507 -0.616,0.764 -0.936,1.675 -0.924,2.637 0.016,1.179 0.547,2.291 1.46,3.073 -0.299,0.278 -0.551,0.555 -0.759,0.842 -0.222,0.305 -0.811,1.112 -0.568,2.07 0.244,0.965 1.046,1.346 1.977,1.787 l 0.053,0.026 c 1.799,0.855 2.704,2.556 2.691,5.052 l -0.013,0.251 c 0.013,1.019 0.503,2.001 1.346,2.692 0.782,0.646 1.804,0.994 2.876,0.98 1.169,-0.016 2.286,-0.479 3.065,-1.267 0.695,-0.704 1.069,-1.605 1.056,-2.538 -0.133,-2.629 0.72,-4.43 2.532,-5.352 0.855,-0.438 1.827,-0.929 2.038,-2.008 0.202,-1.036 -0.501,-1.855 -0.767,-2.164 -0.173,-0.199 -0.367,-0.391 -0.607,-0.598 0.049,-0.039 0.097,-0.078 0.14,-0.122 0.785,-0.795 1.21,-1.848 1.195,-2.963 -0.014,-1.049 -0.422,-2.04 -1.152,-2.802 0.173,-0.371 0.302,-0.752 0.411,-1.138 3.012,3.069 6.146,6.17 9.354,9.256 1.563,1.503 3.338,2.624 5.244,3.339 -2.545,3.059 -4.068,7.019 -4.08,11.404 -0.025,9.732 7.946,17.678 17.771,17.714 h 0.063 c 4.574,0 8.924,-1.828 12.254,-5.152 3.387,-3.379 5.247,-7.822 5.24,-12.51 -0.008,-4.388 -1.527,-8.355 -4.068,-11.423 2.108,-0.773 4.089,-2.056 5.918,-3.847 C -9.824,18.174 -6.11,14.382 -2.52,10.716 0.452,7.681 1.371,3.775 0,0 m -15.958,55.978 c -22.922,12.638 -51.748,4.301 -64.386,-18.621 -12.638,-22.922 -4.3,-51.748 18.621,-64.386 22.922,-12.637 51.749,-4.3 64.386,18.621 12.638,22.922 4.301,51.749 -18.621,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(22.9158,55.0542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.094,-0.332 -2.052,-0.845 -3.173,-0.83 l -5.468,0.074 c -1.137,0.015 -3.164,0.606 -3.234,0.942 -0.005,0.025 0.042,0.076 0.158,0.131 1.083,0.512 4.612,2.596 4.54,7.917 l -0.007,0.043 c 0.026,0.26 0.226,0.449 0.314,0.519 0.264,0.22 0.643,0.341 1.039,0.335 0.764,-0.008 1.335,-0.477 1.334,-0.884 -0.14,-2.761 0.594,-4.976 2.182,-6.584 0.578,-0.585 1.277,-0.997 1.954,-1.395 L -0.116,0.124 C -0.054,0.087 0.007,0.037 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(12.2189,51.4964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 9.436,-0.127 c 0.345,-0.006 0.67,-0.144 0.92,-0.397 0.244,-0.252 0.377,-0.582 0.371,-0.932 -0.01,-0.722 -0.605,-1.302 -1.328,-1.293 l -9.436,0.128 c -0.345,0.004 -0.67,0.142 -0.92,0.396 -0.243,0.249 -0.376,0.58 -0.371,0.932 C -1.319,-0.571 -0.723,0.009 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g50",
    transform: "translate(11.3982,46.1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.255,-0.05 0.506,-0.077 0.747,-0.081 l 9.434,-0.127 c 0.169,-0.003 0.331,0.018 0.488,0.038 0.304,-0.667 0.454,-1.357 0.445,-2.053 l -0.11,-8.179 c -0.017,-1.29 -0.537,-2.498 -1.465,-3.401 -0.927,-0.902 -2.149,-1.389 -3.44,-1.372 l -1.938,0.026 c -1.28,0.018 -2.48,0.528 -3.378,1.438 -0.919,0.93 -1.415,2.161 -1.396,3.467 l 0.109,8.178 C -0.494,-1.348 -0.324,-0.653 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreastFormulaFeeding);
export default __webpack_public_path__ + "static/media/breast_formula_feeding.a2682446b5822920ab422f0b86dfa10f.svg";
export { ForwardRef as ReactComponent };